export const formatPrice = (price: number): string =>
  price?.toLocaleString("he-IL", { style: "currency", currency: "ILS" })
